import autobind from "autobind-decorator";

export default class CustomQuantity {
  get input() {
    return this.container.querySelector("[data-component=qtyCustom]") || {};
  }

  constructor(container) {
    if (!container) return;
    this.container = container;

    const form = this.container.closest("form");

    form.addEventListener("Product.itemNumber.change", this.productChange);
    form.addEventListener("Product.quantity.change", this.productChange);
  }

  @autobind
  productChange(event) {
    const product = event.detail;

    if (
      (!product.specialQuantity || product.otherQuantitySelected) &&
      product.available
    ) {
      return this.render();
    }

    return this.hide();
  }

  hide() {
    this.container.hidden = true;
    this.input.name = "";
  }

  render() {
    this.container.hidden = false;
    this.input.name = "qty";
  }
}
